import React, {useImperativeHandle} from "react";
import {Box, makeStyles} from "@material-ui/core";
import clsx from "clsx";
import {Scrollbars} from "react-custom-scrollbars";
let _ = require("lodash");

const useStyles = makeStyles(theme => ({
  appMainContentWrapper: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box"
  }
}));

const scrollRef = React.createRef();

let _scrollTop = 0;
let _scrollLeft = 0;

const CmtContent = React.forwardRef(function LayoutContent(props, ref){
  const {children} = props;

  useImperativeHandle(ref, () => ({}));

  const contentRef = React.createRef();
  const classes = useStyles();

  const handleScroll = e => {
    _scrollTop = _getScrollTop();
    _scrollLeft = _getScrollLeft();
  };

  return (
    <Box className={classes.appMainContentWrapper}>
      <Scrollbar
        autoHide={false}
        ref={scrollRef}
        onScroll={_.debounce(handleScroll, 150)}
      >
        {children}
      </Scrollbar>
    </Box>
  );
});

export default CmtContent;
CmtContent.defaultProps = {
  name: "LayoutContent"
};

const Scrollbar = React.forwardRef((props, ref) => {
  return (
    <Scrollbars
      {...props}
      ref={ref}
      hideTracksWhenNotNeeded={true} //之前没用到该属性，但是发现在笔记本下，滚动条不能滚动，也会出现条，所以设置该属性解决问题
    />
  );
});

function _getScrollTop(){
  return scrollRef.current.getScrollTop();
}

function _getScrollLeft(){
  return scrollRef.current.getScrollLeft();
}

export function getScrollTop(){
  return _scrollTop;
}

export function getScrollLeft(){
  return _scrollLeft;
}

export function scrollTop(v){
  scrollRef.current.scrollTop(v);
}

export function scrollLeft(v){
  scrollRef.current.scrollLeft(v);
}
